// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__2cjdd","label":"LabeledBox_label__3CNL5"};